<template>
 <v-dialog v-model="dialogPdf" v-if="this.resultado" fullscreen transition="dialog-bottom-transition" :overlay="false" scrollable>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-btn icon @click.native="close()" dark>
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>{{this.resultado.nomePaciente}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon :href="linkDownload">
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-toolbar>

        <div style="height:100%; overflow: hidden;" :id="`iframeContext_${resultado.id}`">

        </div>
      </v-card>
      
    </v-dialog>

</template>

<script>
export default {

  name: 'pdf-dialog',
  props: {
    resultado: {},
    display: false,
    link: ''
  },
  data () {
    return {
      dialogPdf: false,
      loaded: false,
      linkPdf: '',
      linkDownload: ''
    }
  },
  components: {
  },
  watch: {
    display (value) {
      this.dialogPdf = value
      if (value) {
        this.carregarIframe()
      }
    }
  },
  methods: {
    close () {
      this.dialogPdf = false
      this.loaded = false
      this.$emit('update:display', false)
    },
    carregarIframe () {
      var self = this
      if (self.loaded || !this.dialogPdf) {
        return
      }
      console.log('carregarIframe ---- > ', this.loaded, this.link)
      var iframeContext = document.getElementById(`iframeContext_${this.resultado.id}`)
      iframeContext.innerText = ''
      if (this.link) {
        this.linkDownload = this.link.substr(this.link.indexOf('https://st'))
        console.log('this.linkDownload ' + this.linkDownload)
        console.log('iframe link ' + this.link)
        console.log('id ', this.resultado)
        var iframe = document.createElement('iframe') // document.getElementById(`pdfFrame${this.resultado.id}`)
        iframe.frameBorder = 0
        iframe.width = '100%'
        iframe.height = '100%'
        iframeContext.appendChild(iframe)
        // iframe.contentWindow.location.reload(true)
        iframe.src = this.link
        // <iframe v-if="loaded && resultado" :id="`pdfFrame${this.resultado.id}`" frameborder="0" width="100%" height="100%"></iframe>
        iframe.onload = function () {
          self.loaded = true
          console.log('carregou!!', self.loaded)
        }
        setTimeout(this.carregarIframe, 3000)
      }
    }
  },
  created () {
  },
  mounted () {
    // this.loaded = true
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PdfDialog.vue?e7fe4e06